import { type UploadResult } from '../../features/DiscoveryFileUpload/data-layer/types';
import {
  setDiscoveryFileUploadError,
  setDiscoveryFileUploadResult,
  setIsPreviewTable,
} from '../../features/DiscoveryFileUpload/data-store/DiscoveryFileUploadSlice';
import { type AppDispatch } from '../../redux/obNextGenStore';
import Logger from '../../services/loggerService';

export const HEADER_MAPPING: Record<string, string> = {
  APPLICATIONNAME: 'applicationName',
  DESCRIPTION: 'description',
  CREATEDBY: 'createdBy',
  CREATEDATE: 'createDate',
  UPDATEDBY: 'updatedBy',
  UPDATEDATE: 'updateDate',
  OWNER: 'owner',
  CATEGORY: 'category',
  APPLICATIONSTATUS: 'applicationStatus',
  ENVIRONMENT: 'environment',
  JUSTIFICATION: 'justification',
  APPLICATIONTYPE: 'applicationType',
  HOSTNAME: 'hostname',
  CRITICALITY: 'criticality',
  CUSTOMPROPERTY1: 'customProperty1',
  CUSTOMPROPERTY2: 'customProperty2',
  CUSTOMPROPERTY3: 'customProperty3',
  CUSTOMPROPERTY4: 'customProperty4',
  CUSTOMPROPERTY5: 'customProperty5',
};

export const MAX_FILE_COUNT = 1;
export const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
export const MAX_TOTAL_SIZE = 2 * 1024 * 1024; // 2 MB

export const VALID_NAME_REGEX = /^[a-zA-Z0-9!@#&+\-_.\s]*$/;

export const handleUploadResponse = (
  result: UploadResult,
  dispatch: AppDispatch
): void => {
  if ('data' in result && Array.isArray(result.data)) {
    dispatch(setDiscoveryFileUploadResult(result.data));
    dispatch(setIsPreviewTable(true));
  } else if ('error' in result && result.error?.data) {
    dispatch(setDiscoveryFileUploadError(result.error.data));
  } else {
    Logger.error('Unexpected upload result:', result);
  }
};

// Valid Name with REGEX
export const isValidDiscoverySourceName = (
  name: unknown,
  pattern: RegExp
): boolean =>
  typeof name === 'string' && name.trim().length > 0 && pattern.test(name);

// Error Messages in File and Name input
export const UPLOAD_ERROR_MESSAGES: Record<string, string> = {
  'EXCEL.COLUMN.LIMIT.EXCEEDED': 'Upload Error: Exceeds max 30 columns.',
  'UNSUPPORTED.FILE.TYPE': 'This file type is not supported.',
  'UPLOAD.FAILED': 'Upload failed. Please try again.',
  'DISCOVERY_NAME.ALREADY_EXISTS':
    'A discovery source with this name already exists.',
  'INVALID.DISCOVERYSOURCE.NAME': 'Invalid discovery source name.',
  'MANDATORY.FIELDS.MISSING': 'Upload failed: Required fields are missing.',
  'FILE.UPLOAD.SIZE.EXCEEDED': 'Upload Error: File size exceeds allowed limit.',
  'INVALID.DATA.IN.REQUEST': 'Upload Error: Invalid data in request.',
  'INVALID.FILE.NAME': 'Upload Error : Invalid file name.',
};

export const FILE_ERRORS = [
  'EXCEL.COLUMN.LIMIT.EXCEEDED',
  'FILE.UPLOAD.SIZE.EXCEEDED',
  'INVALID.DATA.IN.REQUEST',
  'MANDATORY.FIELDS.MISSING',
  'INVALID.FILE.NAME',
];

export const transformUpdatedHeaders = (
  headers: Record<number, string | null>
): Record<number, string | null> =>
  Object.fromEntries(
    Object.entries(headers).map(([key, value]) => [
      key,
      (value && HEADER_MAPPING[value.trim().toUpperCase()]) ?? value,
    ])
  );
